import { PAYMENT_GATEWAYS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api'
import {
  CashOnDeliveryCreateIntegrationInterface,
  CashOnDeliveryEditIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types'
import httpClient from 'shared/utils/http-client'

export const cashOnDeliveryConnect = (data: CashOnDeliveryCreateIntegrationInterface) =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/cash-on-delivery/connect`, data)

export const cashOnDeliveryDisconnect = () =>
  httpClient.post(`${PAYMENT_GATEWAYS_API}/cash-on-delivery/disconnect`)

export const cashOnDeliveryUpdate = (data: CashOnDeliveryEditIntegrationInterface) =>
  httpClient.put(`${PAYMENT_GATEWAYS_API}/cash-on-delivery/update`, data)
